import axios from 'axios';
import parsePhoneNumber from 'libphonenumber-js';
import { useState } from 'react';
import { Form, Link, useActionData } from 'react-router-dom';

export async function action({ request /*params */ }) {
	const formData = await request.formData();
	const data = Object.fromEntries(formData);
	const options = {};
	if (data.identifier) {
		const phoneNumber = parsePhoneNumber(data.identifier, 'US');
		if (phoneNumber && phoneNumber.isValid()) {
			options.phone_mobile = phoneNumber.number.substring(2); // Remove the +1
		} else {
			options.username = data.identifier;
		}
	}
	try {
		await axios.post('/clients/resetPassword', options);
	} catch (error) {
		return { error };
	}
	return { submitted: true };
}

const ResetPassword = () => {
	const actionData = useActionData();
	const [textAllowed, setTextAllowed] = useState(false);
	return (
		<div className="justify-center py-12 page">
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<h2>Reset Password</h2>
			</div>
			<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
				{actionData?.submitted ? (
					<>
						<p className="pb-4">
							If the username or mobile number exists, a reset link has been
							sent. The link will expire in 15 minutes.
						</p>
						<p>
							Return to{' '}
							<Link to="/login" className="link link-primary">
								Login
							</Link>
						</p>
					</>
				) : (
					<Form className="space-y-6" method="post">
						<p>
							Enter your username or mobile number. If there is a valid mobile
							number associated with your account, you will receive a link to
							reset your password.
						</p>
						{actionData?.error && (
							<p className="py-4 text-red-600">
								An error occurred while attempting to reset the password. Please
								try again.
							</p>
						)}
						<div className="form-control">
							<label htmlFor="identifier" className="label label-text">
								Username or Mobile Number
							</label>
							<input
								id="identifier"
								name="identifier"
								type="text"
								autoComplete="off"
								required
								className="w-full input input-sm input-bordered"
							/>
						</div>
						<div className="form-control">
							<label className="items-start gap-4 cursor-pointer label justify-normal">
								<input
									type="checkbox"
									checked={textAllowed}
									onChange={(e) => setTextAllowed(e.target.checked)}
									className="checkbox"
								/>
								<span className="label-text">
									I consent to receive text messages from Now In Tandem at the
									number provided when account was registered.
								</span>
							</label>
						</div>
						<div>
							<button
								className="text-white btn btn-primary btn-sm btn-block"
								name="form"
								value="resetPassword"
								disabled={!textAllowed}
							>
								Reset Password
							</button>
						</div>
					</Form>
				)}
			</div>
		</div>
	);
};

export default ResetPassword;
